<template>
  <div>
    <b-modal
      size="lg"
      id="charges-modal"
      ref="charges-modal"
      title="Charges"
      centered
			:ok-disabled="okButtonDisabled"
			@ok="submitCharge"
			@hidden="chargesModalReset"
    >
      <b-row>
        <b-col sm="2">
          <label for="input-small"></label>
        </b-col>
        <b-col sm="8" class="pl-0">
          <b-form-group label-cols="2">
            <b-form-radio v-model="chargesObj.isNoCharge" name="isInHouse" :value="true" inline>Customer Charge</b-form-radio>
            <b-form-radio v-model="chargesObj.isNoCharge" name="isInHouse" :value="false" inline>In-House Expense</b-form-radio>
          </b-form-group>
          <b-form-group label="Type" label-align="right" label-cols="2">
            <b-form-select @change="checkOkSubmit" v-model="chargesObj.expenseAccountId">
              <option
                v-for="chargeType in sortSelect(chargesTypes,'accountName')"
                :key="chargeType.id" :value="chargeType.id">{{chargeType.accountName}}</option>
            </b-form-select>  
          </b-form-group>
          <b-form-group label="Description" label-align="right" label-cols="2">
            <b-form-input v-model="chargesObj.description" @input="checkOkSubmit"></b-form-input>
          </b-form-group>            
          <b-form-group label-cols="2" label-align="right" label="Amount">
            <b-form-input type="number" v-model="chargesObj.amount" @input="checkOkSubmit"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button
          v-if="isEdit"
          size="sm"
          variant="danger"
          @click="deleteCharge"
        >
          Delete
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          :disabled="okButtonDisabled"
          size="sm"
          variant="primary"
          @click="ok()"
        >
          OK
        </b-button>
      </template>
    </b-modal>
    <div class="d-flex justify-content-end mb-3">
      <b-button @click="openChargesModal" size="sm" variant="primary">
        <i class="fa fa-plus" aria-hidden="true"></i>
        Add New
      </b-button>
    </div>
    <grid-component
      isResizable
      isReorderable
      isSortable
      :gridId="gridId"
      :navigationField="'accountName'"
      :itemData="charges"
      :fields="fields"
      :onEdit="editChargesModal"
      :onDelete="deleteChargeGrid"
     />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { GRID_ID } from '@/shared/constants';
import chargesListFields from './fields';
import GridComponent from '@/shared/components/GridComponent';

export default {
  components: {
    GridComponent
  },
  props: {
    quoteId: {
      type: [Number, String],
      default: 0
    },
    salesOrderId: {
      type: [Number, String],
      default: 0
    },
    purchaseOrderId: {
      type: [Number, String],
      default: 0
    },
    serviceOrderId: {
      type: [Number, String],
      default: 0
    },
    vendorRmaId: {
      type: [Number, String],
      default: 0
    },
    customerRmaId: {
      type: [Number, String],
      default: 0
    },
    invoiceId: {
      type: [Number, String],
      default: 0
    },
    isExpenseCharge: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields: chargesListFields,
      chargesObj: {
        id: 0,
        expenseAccountId: '',
        description: '',
        amount: '',
        isNoCharge: false,
        isTaxable: false,
        active: true,
      },
      isEdit: false,
      okButtonDisabled: true,
      expenseAccts: 7,
      incomeAccts: 9,
      gridId: '',
      // GRID_ID.QUOTE_CHARGES_GRID,
      // GRID_ID.SALES_ORDER_CHARGES_GRID,
      // GRID_ID.PURCHASE_ORDER_CHARGES_GRID,
      // GRID_ID.SERVICE_ORDER_CHARGES_GRID,
      // GRID_ID.VRMA_CHARGES_GRID,
      //crma_charges_grid: GRID_ID.CRMA_CHARGES_GRID,
  //    GRID_ID.INVOICE_CHARGES_GRID
    }
  },
  computed: {
    ...mapGetters('quotes', {
      // quoteChargesTypes: 'chargesTypes',
      quoteCharges: 'charges',
    }),
    ...mapState('salesOrders', {
      // salesOrderChargesTypes: 'chargesTypes',
      salesOrderCharges: 'charges',
    }),
    ...mapState('purchaseorders', {
      // purchaseOrderChargesTypes: 'chargesTypes',
      purchaseOrderCharges: 'charges',
    }),
    ...mapState('serviceOrders', {
      // serviceOrderChargesTypes: 'chargesTypes',
      serviceOrderCharges: 'charges',
    }),
    ...mapState('vendorrmas', {
      // vendorRmaChargesTypes: 'chargesTypes',
      vendorRmaCharges: 'charges',
    }),
    ...mapState('customerrmas', {
      // customerRmaChargesTypes: 'chargesTypes',
      customerRmaCharges: 'charges',
    }),
    ...mapState('invoices', {
      // invoiceChargesTypes: 'chargesTypes',
      invoiceCharges: 'charges',
    }),
    ...mapState('chargesList', ['expenseAndIncomeAccounts']),
    chargesTypes() {
      // if(this.quoteId) {
      //   return this.quoteChargesTypes;
      // } else if(this.salesOrderId) {
      //   return this.salesOrderChargesTypes;
      // } else if(this.purchaseOrderId) {
      //   return this.purchaseOrderChargesTypes;
      // } else if(this.serviceOrderId) {
      //   return this.serviceOrderChargesTypes;
      // } else if (this.vendorRmaId) {
      //   return this.vendorRmaChargesTypes;
      // } else if (this.customerRmaId) {
      //   return this.customerRmaChargesTypes;
      // } else if (this.invoiceId) {
      //   return this.invoiceChargesTypes;
      // }

      return (this.isExpenseCharge)
      ? this.expenseAndIncomeAccounts.filter(x => x.accountTypeId == this.expenseAccts).sort((a, b) => (a.accountName > b.accountName) ? 1 : -1)
      : (this.chargesObj.isNoCharge)
      ? this.expenseAndIncomeAccounts.filter(x => x.accountTypeId == this.expenseAccts).sort((a, b) => (a.accountName > b.accountName) ? 1 : -1)
      : this.expenseAndIncomeAccounts.filter(x => x.accountTypeId == this.incomeAccts).sort((a, b) => (a.accountName > b.accountName) ? 1 : -1);

    },
    charges() {
      if(this.quoteId) {
        return this.quoteCharges;
      } else if(this.salesOrderId) {
        return this.salesOrderCharges;
      } else if(this.purchaseOrderId) {
        return this.purchaseOrderCharges;
      } else if(this.serviceOrderId) {
        return this.serviceOrderCharges;
      } else if(this.vendorRmaId) {
        return this.vendorRmaCharges;
      } else if(this.customerRmaId) {
        return this.customerRmaCharges;
      } else if (this.invoiceId) {
        return this.invoiceCharges;
      }
    },
  },
  methods: {
    ...mapActions('quotes', {
      getQuoteChargesTypes: 'getChargesTypes',
      getQuoteChargesById: 'getChargesById',
      addNewQuoteCharge: 'addNewCharge',
      deleteQuoteChargeById: 'deleteChargeById',
      editQuoteChargeById: 'editChargeById',
    }),
    ...mapActions('salesOrders', {
      getSalesOrderChargesTypes: 'getChargesTypes',
      getSalesOrderChargesById: 'getChargesById',
      addNewSalesOrderCharge: 'addNewCharge',
      deleteSalesOrderChargeById: 'deleteChargeById',
      editSalesOrderChargeById: 'editChargeById',
    }),
    ...mapActions('purchaseorders', {
      getPurchaseOrderChargesTypes: 'getChargesTypes',
      getPurchaseOrderChargesById: 'getChargesById',
      addNewPurchaseOrderCharge: 'addNewCharge',
      deletePurchaseOrderChargeById: 'deleteChargeById',
      editPurchaseOrderChargeById: 'editChargeById',
    }),
    ...mapActions('serviceOrders', {
      getServiceOrderChargesTypes: 'getChargesTypes',
      getServiceOrderChargesById: 'getChargesById',
      addNewServiceOrderCharge: 'addNewCharge',
      deleteServiceOrderChargeById: 'deleteChargeById',
      editServiceOrderChargeById: 'editChargeById',
    }),
    ...mapActions('customerrmas', {
      getCustomerRmaChargesTypes: 'getChargesTypes',
      getCustomerRmaChargesById: 'getChargesById',
      addNewCustomerRmaCharge: 'addNewCharge',
      deleteCustomerRmaChargeById: 'deleteChargeById',
      editCustomerRmaChargeById: 'editChargeById',
    }),
    ...mapActions('vendorrmas', {
      getVendorRmaChargesTypes: 'getChargesTypes',
      getVendorRmaChargesById: 'getChargesById',
      addNewVendorRmaCharge: 'addNewCharge',
      deleteVendorRmaChargeById: 'deleteChargeById',
      editVendorRmaChargeById: 'editChargeById',
    }),
    ...mapActions('invoices', {
      getInvoicesChargesTypes: 'getChargesTypes',
      getInvoicesChargesById: 'getChargesById',
      addNewInvoicesCharge: 'addNewCharge',
      deleteInvoicesChargeById: 'deleteChargeById',
      editInvoicesChargeById: 'editChargeById',
    }),
    ...mapActions('chargesList', ['getExpenseAndIncomeCharges']),
       // @todo: Add CRUD logic
    handleAdd() {},
    handleEdit() {},
    handleDelete() {},
    checkOkSubmit() {
      //If type and description is not empty
      if(this.chargesObj.expenseAccountId && this.chargesObj.amount) {
        this.okButtonDisabled = false;
      } else {
        this.okButtonDisabled = true;
      }
    },
  	openChargesModal() {
      this.$refs['charges-modal'].show();
    },
    editChargesModal(props) {
      this.isEdit = true;

      this.chargesObj = { ...props };

      this.okButtonDisabled = false;

      this.openChargesModal();
    },
    async submitCharge() {
      //this.chargesObj.quoteId = this.quoteId;
      if(this.isEdit) {
        const editCharge = await this.editCharge();
        //this.$emit('updateTotal',editCharge.quoteSummary);
      } else {
        const newCharge = await this.addNewCharge();
        //this.$emit('updateTotal',newCharge.quoteSummary);
      }

      this.$refs['charges-modal'].hide();
      this.chargesList();
      this.$emit('updateCharge');
    },
    async deleteChargeGrid(props) {
      //If clicked on icon directly, so object needs to be set

      this.chargesObj.isNoCharge = this.chargesObj.noCharge ? true : false;

      this.chargesObj = { ...props };

      await this.deleteCharge();

    },
    async deleteCharge() {
      const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to delete charge?'});
      if (deleteConfirmed) {
        const quoteSummary = await this.deleteChargeById();
        //this.$emit('updateTotal',quoteSummary);
        this.$refs['charges-modal'].hide();
        await this.chargesList();
        this.$emit('updateCharge');
      }
      this.chargesObj = {};
    },
    async addNewCharge() {
      if(this.quoteId) {
        await this.addNewQuoteCharge(this.chargesObj);
      } else if(this.salesOrderId) {
        await this.addNewSalesOrderCharge(this.chargesObj);
      } else if(this.purchaseOrderId) {
        await this.addNewPurchaseOrderCharge(this.chargesObj);
      } else if(this.serviceOrderId) {
        await this.addNewServiceOrderCharge(this.chargesObj);
      } else if(this.vendorRmaId) {
        await this.addNewVendorRmaCharge(this.chargesObj);
      } else if(this.customerRmaId) {
        await this.addNewCustomerRmaCharge(this.chargesObj);
      } else if (this.invoiceId) {
        await this.addNewInvoicesCharge(this.chargesObj);
      }
    },
    async deleteChargeById() {
      if(this.quoteId) {
        await this.deleteQuoteChargeById(this.chargesObj);
      } else if(this.salesOrderId) {
        await this.deleteSalesOrderChargeById(this.chargesObj)
      } else if(this.purchaseOrderId) {
        await this.deletePurchaseOrderChargeById(this.chargesObj)
      } else if(this.serviceOrderId) {
        await this.deleteServiceOrderChargeById(this.chargesObj)
      } else if(this.vendorRmaId) {
        await this.deleteVendorRmaChargeById(this.chargesObj)
      } else if(this.customerRmaId) {
        await this.deleteCustomerRmaChargeById(this.chargesObj)
      } else if(this.invoiceId) {
        await this.deleteInvoicesChargeById(this.chargesObj)
      }
    },
    async editCharge() {
      if(this.quoteId) {
        return await this.editQuoteChargeById(this.chargesObj);
      } else if(this.salesOrderId) {
        return await this.editSalesOrderChargeById(this.chargesObj);
      } else if(this.purchaseOrderId) {
        return await this.editPurchaseOrderChargeById(this.chargesObj);
      } else if(this.serviceOrderId) {
        return await this.editServiceOrderChargeById(this.chargesObj);
      } else if(this.vendorRmaId) {
        return await this.editVendorRmaChargeById(this.chargesObj);
      } else if(this.customerRmaId) {
        return await this.editCustomerRmaChargeById(this.chargesObj);
      } else if(this.invoiceId) {
        return await this.editInvoicesChargeById(this.chargesObj);
      }
    },
    async chargesList() {
      if(this.quoteId) {
        this.gridId = GRID_ID.QUOTE_CHARGES_GRID;
        await this.getQuoteChargesById(this.quoteId);
      } else if(this.salesOrderId) {
        this.gridId = GRID_ID.SALES_ORDER_CHARGES_GRID;
        await this.getSalesOrderChargesById(this.salesOrderId);
      } else if(this.purchaseOrderId) {
        this.gridId = GRID_ID.PURCHASE_ORDER_CHARGES_GRID;
        await this.getPurchaseOrderChargesById(this.purchaseOrderId);
      } else if(this.serviceOrderId) {
        this.gridId = GRID_ID.SERVICE_ORDER_CHARGES_GRID;
        await this.getServiceOrderChargesById(this.serviceOrderId);
      } else if(this.vendorRmaId) {
        this.gridId = GRID_ID.VRMA_CHARGES_GRID;
        await this.getVendorRmaChargesById(this.vendorRmaId);
      } else if(this.customerRmaId) {
        this.gridId = GRID_ID.CRMA_CHARGES_GRID;
        await this.getCustomerRmaChargesById(this.customerRmaId);
      } else if(this.invoiceId) {
        this.gridId = GRID_ID.INVOICE_CHARGES_GRID;
        await this.getInvoicesChargesById(this.invoiceId);
      }
    },
    chargesModalReset() {
      this.chargesObj = {
        id: 0,
        expenseAccountId: '',
        description: '',
        amount: '',
        isNoCharge: false,
        isTaxable: false,
        active: true,
      };

      if(this.quoteId) {
        this.chargesObj = { ...this.chargesObj, quoteId: this.quoteId, };
      } else if(this.salesOrderId) {
        this.chargesObj = { ...this.chargesObj, salesOrderId: this.salesOrderId, };
      } else if(this.purchaseOrderId) {
        this.chargesObj = { ...this.chargesObj, purchaseOrderId: this.purchaseOrderId, };
      } else if(this.serviceOrderId) {
        this.chargesObj = { ...this.chargesObj, serviceOrderId: this.serviceOrderId, };
      } else if(this.vendorRmaId) {
        this.chargesObj = { ...this.chargesObj, vendorRmaId: this.vendorRmaId, };
      } else if(this.customerRmaId) {
        this.chargesObj = { ...this.chargesObj, rmaId: this.customerRmaId, };
      } else if (this.invoiceId) {
        this.chargesObj = { ...this.chargesObj, invoiceId: this.invoiceId };
      }

      this.isEdit = false;

      this.okButtonDisabled = true;
    },
  },
  async mounted() {
    if(this.quoteId) {
      this.chargesObj = { ...this.chargesObj, quoteId: this.quoteId, };
      this.gridId = GRID_ID.QUOTE_CHARGES_GRID;
      // await this.getQuoteChargesTypes();
    } else if(this.salesOrderId) {
      this.chargesObj = { ...this.chargesObj, salesOrderId: this.salesOrderId, };
      this.gridId = GRID_ID.SALES_ORDER_CHARGES_GRID;
      // await this.getSalesOrderChargesTypes();
    } else if(this.purchaseOrderId) {
      this.chargesObj = { ...this.chargesObj, purchaseOrderId: this.purchaseOrderId, };
      this.gridId = GRID_ID.PURCHASE_ORDER_CHARGES_GRID;
      // await this.getPurchaseOrderChargesTypes();
    } else if(this.serviceOrderId) {
      this.chargesObj = { ...this.chargesObj, serviceOrderId: this.serviceOrderId, };
      this.gridId = GRID_ID.SERVICE_ORDER_CHARGES_GRID;
      // await this.getServiceOrderChargesTypes();
    } else if(this.vendorRmaId) {
      this.chargesObj = { ...this.chargesObj, vendorRmaId: this.vendorRmaId, };
      this.gridId = GRID_ID.VRMA_CHARGES_GRID;
      // await this.getVendorRmaChargesTypes();
    } else if(this.customerRmaId) {
      this.chargesObj = { ...this.chargesObj, rmaId: this.customerRmaId, };
      this.gridId = GRID_ID.CRMA_CHARGES_GRID;
      // await this.getCustomerRmaChargesTypes();
    } else if (this.invoiceId) {
      this.chargesObj = { ...this.chargesObj, invoiceId: this.invoiceId, };
      this.gridId = GRID_ID.INVOICE_CHARGES_GRID;
      // await this.getInvoicesChargesTypes();
    }
    await this.chargesList();
    await this.getExpenseAndIncomeCharges();
  },
};
</script>
